import React from 'react';
import { Spinner, ProgressBar } from 'react-bootstrap';

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <Spinner animation="border" variant="light" size="lg" className="gradient-spinner" />
      <h3 className="mt-3">حياك في موقع حمد المنيف</h3>
      <ProgressBar animated now={100} className="w-50 mt-3" variant="light" />
      <p className="text-gray mt-2">ثواني وبيحمل  . . .</p>
    </div>
  );
}

export default LoadingScreen;